import { useState, useContext } from 'react'
import './forgot.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { auth } from '../../services/firebaseConnection'; 
import { sendPasswordResetEmail } from 'firebase/auth';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import 'react-toastify/dist/ReactToastify.css';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const { EmailExist } = useContext(AuthContext)
    

    async function handleForgotPassword(e) {
        e.preventDefault();
    
        if (email !== '') {
            try {
                const emailExists = await EmailExist(email);
                if (emailExists) {
                    await sendPasswordResetEmail(auth, email);
                    toast.success('Link de recuperação de senha enviado para o seu email.');
                } else {
                    toast.error('Nenhum usuário encontrado com este e-mail.');
                }
            } catch (err) {
                    toast.error(`Erro ao enviar o e-mail.`);
            }
        } else {
            toast.error('Por favor, insira um email válido.');
        }
    }

    return (
        <div className="container-fluid d-flex justify-content-center align-items-center forgot-password-container">
            <div className='forgot-password-area text-center'>
                <h2>Recuperar Senha</h2>
                <form onSubmit={handleForgotPassword}>
                    <div className="input-group my-3">
                        <input
                            className="form-control inpt"
                            type='email'
                            placeholder='usuario@email.com'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <button type='submit' className="btn btn-dark w-100">
                        Enviar link de recuperação
                    </button>
                </form>
                <Link to="/" className="d-block mt-3 link-secondary">Voltar</Link>
            </div>
        </div>
    );
}
